var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketballIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F75614"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2465 16.3483C27.8915 15.4098 31.9239 16.3676 34.7781 19.2218C37.6324 22.076 38.5902 26.1086 37.6515 29.7537C35.9102 31.7434 33.3518 33 30.5 33C25.2533 33 21 28.7467 21 23.5C21 20.6481 22.2567 18.0897 24.2465 16.3483Z",
    fill: "#FF715E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9243 18.4862C28.2043 19.9249 26.5 24.0872 26.5 24.5C26.5 25.5 28.5 27.5 29.5 27.5C30.3329 27.5 34.2875 26.2939 35.5859 24.2953C35.1655 22.9567 34.4248 21.6969 33.3639 20.636C32.3613 19.6334 31.181 18.9168 29.9243 18.4862Z",
    fill: "#FF9C90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9604 26.0618C34.905 25.9327 31.7821 27.0464 29.4143 29.4142C27.0466 31.782 25.9328 34.9048 26.0618 37.9601C25.3845 37.9024 24.7115 37.7823 24.0522 37.5996C24.0235 34.1431 25.3417 30.6585 28.0001 28C30.6586 25.3415 34.1433 24.0233 37.5999 24.0521C37.7826 24.7114 37.9027 25.3844 37.9604 26.0618Z",
    fill: "#C82400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0471 28.0172C16.1096 28.695 16.2349 29.368 16.4228 30.027C19.8973 30.0533 23.3951 28.73 26.0627 26.0624C28.7303 23.3948 30.0535 19.897 30.0273 16.4225C29.3683 16.2346 28.6952 16.1093 28.0175 16.0467C28.1476 19.1268 27.0275 22.2692 24.6485 24.6482C22.2695 27.0272 19.1271 28.1473 16.0471 28.0172Z",
    fill: "#C82400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8894 36.8565C32.5382 36.534 33.1507 36.1494 33.719 35.7104C32.9643 31.8808 31.109 28.2339 28.1506 25.2755C25.4201 22.545 22.103 20.7541 18.5972 19.9011C18.133 20.4501 17.7216 21.0451 17.3708 21.6784C20.8106 22.3652 24.0827 24.0361 26.7364 26.6897C29.5953 29.5487 31.3136 33.1256 31.8894 36.8565Z",
    fill: "#C82400"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26.9997,
    r: 10,
    transform: "rotate(90 27 26.9997)",
    stroke: "#C82400",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballIcon);
export default __webpack_public_path__ + "static/media/basketball-icon.5f33960a5a5c2dcd6173defa69493e2b.svg";
export { ForwardRef as ReactComponent };